import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '~/lib/utils';
import Icon, { IconName } from './ui/Icon';

const variants = cva('flex items-center gap-3.5 text-white rounded-md p-4', {
  variants: {
    variant: {
      error: 'border-1 border-white/16 bg-emergency',
      info: '',
      success: 'border-1 border-white/16 bg-success',
      loading: '',
      blank: '',
      custom: '',
    },
  },
  defaultVariants: {
    variant: 'info',
  },
});

export interface AlertProps extends VariantProps<typeof variants> {
  className?: string;
  description: string | React.ReactNode;
}

const iconMap: Record<string, IconName> = {
  error: 'emergency',
  info: 'info',
  success: 'checkCircle',
  loading: 'info',
};

export default function Alert({ variant, description, className }: AlertProps) {
  return (
    <div className={cn(variants({ variant }), className)}>
      {!!variant && iconMap[variant] && (
        <>
          <Icon name={iconMap[variant] as IconName} />
          <div className="border-r-1 border-white/20 min-h-[40px]" />
        </>
      )}
      <p>{description}</p>
    </div>
  );
}
